import { render, staticRenderFns } from "./preview-asset-data.vue?vue&type=template&id=826c233c&scoped=true&"
import script from "./preview-asset-data.vue?vue&type=script&lang=ts&"
export * from "./preview-asset-data.vue?vue&type=script&lang=ts&"
import style0 from "./preview-asset-data.vue?vue&type=style&index=0&id=826c233c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826c233c",
  null
  
)

export default component.exports